(function() {
    'use strict';

    angular
        .module('app')
        .controller('commonController', commonController);

    function commonController($sce) {
        var vm = this;
        onInit();

        function onInit() {
            menuService.getInformationBySerilNo(getMenuQueryString()).then(function(data) {
                menuService.generateUrl(data.data, sessionStorage.getItem('token'));
                vm.url = $sce.trustAsResourceUrl(data.data.url);
            });
            vm.url = $sce.trustAsResourceUrl(sessionStorage.getItem('iframeUrl'));
        }
    }
})();
